/*
 * @Author: Michael 
 * @Date: 2018-09-19 19:17:47 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-08-16 15:53:05
 */

import Vue, { VueConstructor } from 'vue';
import CommonModalComp from './Modal.vue';
import SolitaireModalComp from './SolitaireModal.vue';
import GachaModalComp from './GachaModal.vue';
import GroupTypeModal from './GroupTypeModal.vue'
import SuccessComp from './Success.vue';

import store from '@/store';
import getActivityType from '@/common/utils/getActivityType';

interface InstanceState {
  $el: any,
  instId: string,
  leadersInstId?: string,
  type: string,
  closed: boolean,
  close: Function,
  visible: boolean,
  ok: Function,
  cancel: Function,
  classname: string,
  title: string,
  subTitle: string,
  oneBtn: boolean,
  okText: string,
  cancelText: string,
  mainTextColor: string,
  titleSection: any,
  section: any,
  modalSection: any,
  getterUid: string,
  getterName: string,
  getterInstVOList?: Array<object>,
  getterPhone: string,
  signupItemConfig: string,
  documentTitle: string,
  hasOpenSMSVerify: boolean,
  groupImageList: Array<string>,
  madeByOrg?: boolean,
  seqNo?:number
}

// const instancePool: Array<VueConstructor> = []; // 实例池
let activityType =  getActivityType();
let ModalComp = CommonModalComp;
if(activityType === "solitaireType"){
  ModalComp = SolitaireModalComp;
}else if(activityType === "gachaType"){
  ModalComp = GachaModalComp;
} else if (activityType === 'groupType') {
  ModalComp = GroupTypeModal;
} else {
  ModalComp = CommonModalComp;
}

// const ModalComp = getActivityType() === 'solitaireType' ? SolitaireModalComp : CommonModalComp;
const ModalConstructor = Vue.extend(ModalComp);
const SuccessConstructor = Vue.extend(SuccessComp)

const getAnInstance = (constructor: VueConstructor) => {
  // if (instancePool.length > 0) {
  //   const instance = instancePool.shift();
  //   return instance;
  // }
  return new constructor({
    el: document.createElement('div')
  })
}

const removeDom = (event: Event) => {
  if ((event.target as any).parentNode) {
    (event.target as any).parentNode.removeChild(event.target);
  }
}

ModalConstructor.prototype.close = function () {
  this.visible = false;
  this.$el.addEventListener('transitionend', removeDom);
  this.closed = true;
  // instancePool.push(this);
}
SuccessConstructor.prototype.close = function () {
  this.visible = false;
  this.$el.addEventListener('transitionend', removeDom);
  this.closed = true;
  // instancePool.push(this);
}
/**
 *
 *
 * @param {*} [options={
 * ok 确定的回调函数
 * cancel 取消的回调函数
 * okText
 * cancelText
 * title
 * content  <html>
 * oneBtn  <boolean>
 * className
 * mainTextColor
 * }]
 */
const Modal = (options: InstanceState) => {
  const { ok, cancel, classname, title, subTitle, oneBtn, okText, cancelText, type, groupImageList, seqNo } = options;
  let instance = <InstanceState>getAnInstance(ModalConstructor);
  if (type && type === 'success') {
    instance = <InstanceState>getAnInstance(SuccessConstructor);
  }
  instance.closed = false;
  const { 
    getters: { 
      uid,
      name,
      instVOList,
      phone,
      mainTextColor,
      signupItemConfig,
      hasOpenSMSVerify,
      documentTitle,
      titleSection,
      section,
      modalSection,
      instId,
      madeByOrg,
      leadersInstId,
    }
  } = store;

  instance.ok = function(name: string, phone: string, authCode: string, additionalInfo: string, selectInstId?: string, group?: number) {
    if (options.ok) {
      options.ok(name, phone, authCode, additionalInfo, selectInstId, group);
    }
    instance.close();
  };
  instance.cancel = function () {
    if (options.cancel) {
      options.cancel();
    }
    instance.close();
  };
  instance.classname = classname || '';
  instance.title = title || '报名参与';
  instance.subTitle = subTitle || '我们需要收集您的姓名和手机号，并同步给机构用于活动报名'
  instance.okText = okText || '确定';
  instance.cancelText = cancelText || '取消';

  instance.mainTextColor = mainTextColor;
  instance.instId = instId;
  instance.getterUid = uid;
  instance.getterName = name;
  instance.getterInstVOList = instVOList;
  instance.madeByOrg = madeByOrg;
  instance.leadersInstId = leadersInstId;
  instance.getterPhone = phone;
  instance.signupItemConfig = signupItemConfig;
  instance.documentTitle = documentTitle;
  
  instance.hasOpenSMSVerify = hasOpenSMSVerify;
  instance.titleSection = titleSection;
  instance.section = section;
  instance.modalSection = modalSection;
  instance.groupImageList = groupImageList;

  instance.seqNo = seqNo || 0;
  
  (document.querySelector('.mask-layer') as HTMLElement).appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.visible = true;
    instance.$el.removeEventListener('transitionend', removeDom);
  });

  return instance;
}

export default Modal;
